<template>
  <div>
    <component :is="component" class="py-8 py-md-12 py-lg-16">
      <TitleWidget
        v-if="title"
        :title="title"
        :subtitle="subtitle"
        class="primary--text justify-center text-center"
      />

      <v-chip v-if="date" class="mb-3 ml-auto px-6" color="primary">
        <v-icon small="small" left="left">far fa-clock</v-icon>
        <span>{{ date }}</span>
      </v-chip>

      <LoadingWidget v-if="loading" class="py-16" />

      <transition name="fade">
        <template v-if="!loading">
          <slot />
        </template>
      </transition>
    </component>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import { VContainer } from "vuetify/lib/components";

export default {
  props: {
    title: String,
    subtitle: String,
    date: String,
    loading: {
      type: Boolean,
      default: false,
    },
    container: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    component() {
      return this.container ? "v-container" : "div";
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    VContainer,
  },
};
</script>
